import { ChatBubbleBottomCenterTextIcon } from '@heroicons/react/24/outline';
import { WorksheetBase, WorksheetStatusEnum } from '../../../../types/worksheet';
import NoCommentsHelper from './NoCommentsHelper';
import CommentsList from './CommentsList';
import { commentsReducer } from './utils';
import { useWorkpaperContext } from '../../../../providers/WorkpaperProvider';

type CommentsContainerProps = {
    worksheet: WorksheetBase;
    showTitle?: boolean;
};

function CommentsContainer({ worksheet, showTitle = true }: CommentsContainerProps): JSX.Element {
    const { readOnly } = useWorkpaperContext();

    const commentsStats = worksheet.internalComments.reduce(commentsReducer, { active: 0, resolved: 0 });
    const totalComments = commentsStats.active + commentsStats.resolved;

    return (
        <div className="flex flex-col gap-4 h-full">
            {/* TITLE */}
            {showTitle && (
                <div className="flex items-center">
                    <ChatBubbleBottomCenterTextIcon className="h-5 w-5" />
                    <p className="text-gray-800 ml-2 leading-4">
                        <span className="font-medium">
                            {commentsStats.resolved} of {totalComments}
                        </span>{' '}
                        comments resolved
                    </p>
                </div>
            )}

            {totalComments === 0 ? (
                <NoCommentsHelper
                    worksheetId={worksheet.id}
                    disableAction={worksheet.status === WorksheetStatusEnum.EXCLUDED || readOnly}
                />
            ) : (
                <CommentsList worksheet={worksheet} />
            )}
        </div>
    );
}

export default CommentsContainer;
